import { Value } from '@philips-emr/tws-core';
import { Formatter, Validation } from '@philips-emr/tws-core/lib/services/model-service';
import { format, getPattern, parse, validate as validateDate } from '@philips-emr/tws-model/lib/formatters/date/date';
import { DateFormatterOptions } from '@philips-emr/tws-model/lib/formatters/date/date-types';

function validate(value: Value): Validation[] {
  let valid;
  if (value) {
    const currentDate = new Date();
    const minimumDate = new Date('1900-01-01');
    const valueDate = new Date(value as string);

    const isValidDate = validateDate(value)[0].valid;

    if (isValidDate) {
      valid = valueDate <= currentDate && valueDate >= minimumDate;
    } else {
      valid = true;
    }
  } else {
    valid = true;
  }

  return [{
    message: !valid ? 'tws.validator.invalid-date' : '',
    name: 'prevent-future-date',
    valid,
  }];
}

const PreventFutureDateFormatter: Formatter<string, DateFormatterOptions> = {
  format,
  getPattern,
  parse,
  validate,
};

export default PreventFutureDateFormatter;
